<section *ngFor="let item of preContrattuale; index as i" class="contract-section">
  <h1>{{item.text}}</h1>
  <embed [src]="item.url" style="width: 100%;height: 300px" type="application/pdf">
  <smart-form [fields]="item.signatures"></smart-form>
</section>

@if (form)
{
<form [formGroup]="form" class="form-container">
  <h2 style="margin-bottom: 2rem;">Spazio riservato al firmatario</h2>

  <mat-form-field appearance="outline" class="cell-1of2">
    <mat-label>OTP</mat-label>
    <input matInput type="text" [formControlName]="'otp'">
    <span class="resend-button" (click)="resend()">Reinvia</span>
  </mat-form-field>

  <div class="button-container">
    <button mat-flat-button color="accent" (click)="confirm()" [disabled]="!formIsValid">FIRMA*</button>
  </div>
  <div>*Il firmatario autorizza la firma cliccando sul pulsante</div>

</form>
}